import { Price } from "./Price"
import Holding from "./Holding"
import GICHolding from "./GICHolding"
import Portfolio from "./Portfolio"
import CashHolding from "./CashHolding"
import BondHolding from "./BondHolding"
import SaveHolding from "./SaveHolding"
import { ITransRow } from "../shared/ITransaction"

export default function createHolding(portfolio:Portfolio, ticker:string, trans:ITransRow[]){
    if (Price.isSave(ticker)) return new SaveHolding(portfolio, ticker, trans)
    else if (Price.isGIC(ticker)) return new GICHolding(portfolio, ticker, trans)
    else if (Price.isBond(ticker)) return new BondHolding(portfolio, ticker,trans)
    else if (Price.isCash(ticker)) return new CashHolding(portfolio, ticker, trans)
    else return new Holding(portfolio, ticker, trans)
}